import { EyeIcon, EyeOffIcon, CopyIcon, Menu } from "@carbon6/c6-frontend-design";
import type { Dataset } from "../../domain/dataset";
import { isDatasetHidden } from "../../domain/dataset";

type DatasetRowActionsMenuProps = {
  dataset: Dataset;
  onCopySourceRef: (dataset: Dataset) => void;
  onHide: (dataset: Dataset) => void;
  onShow: (dataset: Dataset) => void;
};

/**
 * 목록 행과 상세 헤더가 함께 쓰는 액션 메뉴.
 *
 * 숨김은 조직 공용이고 가역이라 삭제 톤을 쓰지 않는다 — 되돌릴 수 있는 동작을 위험하게 그리면
 * 사용자가 쓰지 않는다.
 */
export function DatasetRowActionsMenu({
  dataset,
  onCopySourceRef,
  onHide,
  onShow,
}: DatasetRowActionsMenuProps) {
  const hidden = isDatasetHidden(dataset);

  return (
    <Menu label={`${dataset.displayName} 작업`}>
      <Menu.Trigger label="Dataset 작업" size="sm" />
      <Menu.Item icon={<CopyIcon />} onSelect={() => onCopySourceRef(dataset)}>
        원본 주소 복사
      </Menu.Item>
      {hidden ? (
        <Menu.Item icon={<EyeIcon />} onSelect={() => onShow(dataset)}>
          다시 보이기
        </Menu.Item>
      ) : (
        <Menu.Item icon={<EyeOffIcon />} onSelect={() => onHide(dataset)}>
          숨기기
        </Menu.Item>
      )}
    </Menu>
  );
}
